<template>
  <div
    v-if="status"
    :class="['box-time row', isReverse ? 'reverse text-right' : '']"
    style="margin-bottom: 2px"
  >
    <div
      class="col-auto"
      :style="`${showStatus ? 'padding-top: 1px' : ''}`"
    >
      <component
        v-if="showStatus"
        :is="statusIcon"
      />

      <q-spinner-ios
        v-if="showLoading"
        color="primary"
        dense
        size="12px"
      />

      <IconNotSended
        v-if="showError"
      />
    </div>

    <div
      class="col-auto"
      v-if="showStatus"
    >
      {{ status }}
    </div>

    <div
      class="col-auto text-red"
      v-if="showError"
    >
      Falha no envio
    </div>

    <div
      v-if="showStatus"
      class="col-auto q-px-xs"
    />

    <q-tooltip
      v-if="showStatus"
      :anchor="isReverse ? 'center left' : 'center right'"
      :self="isReverse ? 'center right' : 'center left'"
      class="col-auto box-text q-pa-sm dont-break-out"
    >
      <span>
        <q-icon
          name="mdi-check"
          class-name="bg-grey-3"
          size="sm"
        />
        {{ formatTimestamp(createdAt) }} - Envio
      </span>

      <br v-if="deliveredAt">
      <span v-if="deliveredAt">
        <q-icon
          name="mdi-check-all"
          class-name="bg-grey-3"
          size="sm"
        />
        {{ formatTimestamp(deliveredAt) }} - Entregue
      </span>

      <br v-if="readedAt">
      <span v-if="readedAt">
        <q-icon
          name="mdi-check-all"
          :class="{ 'check-whatsapp': readedAt }"
          size="sm"
        />
        {{ formatTimestamp(readedAt) }} - Lido
      </span>
    </q-tooltip>
  </div>
</template>

<script>
import IconNotSended from '@/assets/icons/IconNotSended.svg'
import ReadedMessageIcon from '@/assets/icons/ReadedMessageIcon.svg'
import SendedMessageIcon from '@/assets/icons/SendedMessageIcon.svg'
import DeliveredMessageIcon from '@/assets/icons/DeliveredMessageIcon.svg'
import moment from 'moment-timezone'

export default {
  components: {
    IconNotSended,
    ReadedMessageIcon,
    SendedMessageIcon,
    DeliveredMessageIcon
  },

  props: {
    status: {},
    statusIcon: {},
    isReverse: {},

    createdAt: {},
    deliveredAt: {},
    readedAt: {}
  },

  data () {
    const vm = this
    const showLoading = !vm.statusIcon && (Date.now() - Number(vm.createdAt)) <= 30000
    return { showLoading }
  },

  computed: {
    showStatus () {
      const vm = this
      return Boolean(vm.statusIcon)
    },

    showError () {
      const vm = this
      if (vm.showStatus) return false
      return !vm.showStatus && (Date.now() - Number(vm.createdAt)) > 30000
    }
  },

  mounted () {
    this.isMounted = true
    this.checkStatus()
  },

  beforeDestroy () {
    this.isMounted = false
  },

  methods: {
    checkStatus () {
      const vm = this
      if (!vm.isMounted) return
      if (!vm.showLoading) return

      vm.$nextTick().then(() => {
        const showLoading = !vm.showStatus && (Date.now() - Number(vm.createdAt)) <= 30000
        if (showLoading) return setTimeout(() => vm.checkStatus(), 1000)
        vm.showLoading = false
      })
    },

    formatTimestamp (timestamp) {
      if (!timestamp) return ''

      if (String(timestamp).length === 10) {
        timestamp *= 1000
      }

      const now = moment()
      const messageTime = moment(timestamp)

      if (now.isSame(messageTime, 'day')) {
        return messageTime.format('[Hoje], HH:mm')
      } else if (now.subtract(1, 'days').isSame(messageTime, 'day')) {
        return messageTime.format('[Ontem], HH:mm')
      } else {
        return messageTime.format('DD/MM/YYYY, HH:mm')
      }
    }
  }
}
</script>
